import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FaTimes } from 'react-icons/fa'

const Component = styled.button`
  font-size: ${props => props.theme.font.size.mobile.h2};
  color: ${props => props.theme.palette.white};
  background: none;
  border: none;
  appearance: none;
`
const CloseButton = ({ className, onClick }) => (
  <Component className={className} onClick={onClick}>
    <FaTimes />
  </Component>
)

CloseButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
}

export default CloseButton
